export const CUSTOMERPROFILEID = "@AUDIENCIAS/CUSTOMERPROFILEID";

export const SELECT_CUSTOMER_PROFILE = "@AUDIENCIAS/SELECT_CUSTOMER_PROFILE";
export const SET_IS_ADMIN = "@AUDIENCIAS/SET_IS_ADMIN";

export const CONTAINER_PROFILE = "@AUDIENCIAS/CONTAINER_PROFILE";

export const SET_PROFILE_NAME = "@AUDIENCIAS/SET_PROFILE_NAME";
export const SET_MENU_LIST = "@AUDIENCIAS/SET_MENU_LIST";
